import { normalizeWidgetData, type IdeationWidgetDataUnion } from '../model/ideation-widget.types';
import { useTranslation } from 'react-i18next';

const MAX_PREVIEW_IDEAS = 4;

interface Props {
  data: IdeationWidgetDataUnion;
}

/**
 * Store-free, prop-only preview of an ideation widget: the campaign title plus
 * a few idea titles. Normalizes V1/V2 data the same way the full widget does,
 * but never touches the widget store or export deps.
 */
export const IdeationThumbnail = (props: Props) => {
  const { t } = useTranslation('contentTest');

  const data = normalizeWidgetData(props.data);
  const ideas = Array.isArray(data.ideas) ? data.ideas : [];
  const previewIdeas = ideas.slice(0, MAX_PREVIEW_IDEAS);

  return (
    <div className="flex h-full flex-col gap-2 overflow-hidden">
      <p className="truncate text-sm font-semibold text-[#1A1A1A]">
        {data.title || t('ideationWidget.ideationThumbnail.ideation')}
      </p>
      <ol className="flex flex-col gap-1">
        {previewIdeas.map((idea, index) => (
          <li key={idea.id} className="line-clamp-1 text-xs text-[#1A1A1A]">
            {index + 1}. {idea.title}
          </li>
        ))}
      </ol>
    </div>
  );
};
